<template>
  <div>
    <input-with-validation :disabled="readOnly" ref="input" :vid="randomVid" :field-label="$attrs.label" :rules="rules" expanded>
      <template #custom="{ handleChange }">
        <div class="control">
          <!-- eslint-disable-next-line vue/valid-v-for -->
          <b-radio v-for="choice in choices" v-model="model" @update:modelValue="handleChange" :native-value="choice">{{ choice }}</b-radio>
        </div>
      </template>
    </input-with-validation>
  </div>
</template>

<script>
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
import InputWithValidation from "@/components/validation/InputWithValidation";

export default {
  name: "RadioElementRenderer",
  components: {InputWithValidation},
  mixins: [ElementRendererMixin],
  mounted() {
    if (this.model) {
      this.$refs.input.$refs.field.handleChange(this.model)
    }
  }
}
</script>

<style scoped>

</style>
